import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';

import NodeEditor from './NodeEditor';
import GraphViewController from './GraphViewController';
import { addNodeForButton as addNodeForButtonApi } from '../services/api';

class GraphEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNodeId: null,
      editingNode: false,
      deletingNode: false,
      temporaryNodes: [],
      temporaryEdges: [],
    };
  }

  selectNode = (node) => {
    // very bad solutions (bug empty buttons on select other node) :(

    const { selectedNodeId } = this.state;
    if (selectedNodeId !== null) {
      this.setState({
        selectedNodeId: null,
      });
    }

    setTimeout(() => {
      this.setState({
        selectedNodeId: node.id,
      });
    }, 100)
  };

  cleanNodeSelection = () => {
    const { selectedNodeId } = this.state;
    if (selectedNodeId !== null) {
      this.setState({
        selectedNodeId: null,
      });
    }
  };

  editNode = (node) => {
    const { editNode } = this.props;
    this.setState({
      editingNode: true,
    });

    return editNode(node).then(() => {
      this.setState({
        selectedNodeId: null,
      });
    }).finally(() => {
      this.setState({
        editingNode: false,
      });
    });
  };

  confirmActionBeforeDelete = (node) => {
    const { confirmAction } = this.props;
    const args = [node];
    confirmAction(this.deleteNode, args);
  };

  deleteNode = (node) => {
    const { deleteNode } = this.props;

    this.setState({
      deletingNode: true,
    });
    return deleteNode(node).then(() => {
      this.setState({
        selectedNodeId: null,
      });
    }).finally(() => {
      this.setState({
        deletingNode: false,
      });
    });
  };

  addTemporaryNode = (buttonId) => {
    const { temporaryNodes, temporaryEdges } = this.state;

    const temporaryNodesIds = temporaryNodes.map(tempNode => tempNode.id);

    const temporaryNodeId = Math.min(...temporaryNodesIds) <= -1 ? Math.min(...temporaryNodesIds) - 1 : -1;
    this.setState({
      temporaryNodes: [...temporaryNodes, {
        id: temporaryNodeId, name: '', buttons: [], temporary: true, botAttachments: [],
      }],
      temporaryEdges: [...temporaryEdges, { buttonId, questionId: temporaryNodeId }],
    });
  };

  cleanTemporaryNodes = () => {
    const { addNode } = this.props;
    const { temporaryNodes, temporaryEdges } = this.state;
    if (temporaryNodes.length === 0) {
      return false;
    }

    const temporaryNode = temporaryNodes[0];
    if (temporaryNode.name === '') {
      this.setState({
        temporaryNodes: temporaryNodes.filter(curNode => curNode.id !== temporaryNode.id),
        temporaryEdges: temporaryEdges.filter(curEdge => curEdge.questionId !== temporaryNode.id),
      });
      return false;
    }

    const temporaryNodeEdge = temporaryEdges.find(curEdge => curEdge.questionId === temporaryNode.id);
    if (!temporaryNodeEdge) {
      return false;
    }

    return addNode(temporaryNodeEdge.buttonId, temporaryNode).then((newNode) => {
      this.setState({
        temporaryNodes: temporaryNodes.filter(curNode => curNode.id !== temporaryNode.id),
        temporaryEdges: temporaryEdges.filter(curEdge => curEdge.questionId !== temporaryNode.id),
      });
      return true;
    });
  };

  render() {
    const {
      selectedNodeId, editingNode, deletingNode, temporaryNodes, temporaryEdges,
    } = this.state;
    const {
      nodes, edges, addNotification, readonly, connectButtonToDestination, rootNodeId, user
    } = this.props;
    const selectedNode = lodash.cloneDeep(nodes.find(curNode => curNode.id === selectedNodeId));

    let graphClassNames = 'graph';
    if (readonly) {
      graphClassNames += ' readonly';
    }

    return (
      <div className={graphClassNames} style={{ width: '100%' }}>
        <GraphViewController
          nodesData={[...nodes, ...temporaryNodes]}
          edgesData={[...edges, ...temporaryEdges]}
          rootNodeId={rootNodeId}
          readonly={readonly}
          cleanSelectedNode={this.cleanNodeSelection}
          selectNode={this.selectNode}
          addTemporaryNode={this.addTemporaryNode}
          cleanTemporaryNodes={this.cleanTemporaryNodes}
          connectButtonToDestination={connectButtonToDestination}
        />
        {selectedNode && (
          <NodeEditor
            node={selectedNode}
            editingNode={editingNode}
            deletingNode={deletingNode}
            readonly={readonly}
            addNotification={addNotification}
            editNode={this.editNode}
            deleteNode={this.confirmActionBeforeDelete}
            user={user}
          />
        )}
      </div>
    );
  }
}

GraphEditor.propTypes = {
  nodes: PropTypes.array.isRequired,
  edges: PropTypes.array.isRequired,
  rootNodeId: PropTypes.number.isRequired,
  readonly: PropTypes.bool.isRequired,
  editNode: PropTypes.func.isRequired,
  deleteNode: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
  addNode: PropTypes.func.isRequired,
  connectButtonToDestination: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default GraphEditor;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphEditor.js